import { translate } from "@kaltura/mediaspace-shared-utils";
import { IconButton, TableCell, Tooltip, Typography } from "@kaltura/ds-react-components";
import { TableBody, TableHead, TableRow } from "@kaltura/mediaspace-shared-styled";
import { Remove24Icon, Edit24Icon } from "@kaltura/ds-react-icons";
import { LiveFeature } from "../RestreamDestinationsTypes";
import { StyledTable } from "./StyledComponents";
import { FitContentTableCell, TruncatedContentTableCell } from "@kaltura/mediaspace-shared-ui";

export interface RestreamsTableProps {
    restreams: LiveFeature[];
    onAction: (action: string) => void;
    onStreamSelected: (feature?: LiveFeature) => void;
}

/**
 *  Restreams Table
 */
const RestreamsTable = (props: RestreamsTableProps) => {
    const { restreams, onAction, onStreamSelected } = props;

    return (
        <StyledTable>
            <TableHead>
                <TableRow>
                    <TableCell key={"systemName"} aria-label={translate("Name")} width={"40%"}>
                        <Typography variant={"body1Highlight"}>{translate("Name")}</Typography>
                    </TableCell>
                    <TableCell key={"dismiss"} aria-label={translate("URL")} width={"60%"}>
                        <Typography variant={"body1Highlight"}>{translate("URL")}</Typography>
                    </TableCell>
                    <FitContentTableCell key={"actions"} aria-label={translate("Actions")}>
                        <Typography variant={"body1Highlight"}>{translate("Actions")}</Typography>
                    </FitContentTableCell>
                </TableRow>
            </TableHead>

            <TableBody>
                {restreams.map((restream) => {
                    return (
                        <TableRow key={`restream_row_${restream.id}`}>
                            <TruncatedContentTableCell>{restream.systemName}</TruncatedContentTableCell>
                            <TruncatedContentTableCell>{restream.primaryUrl}</TruncatedContentTableCell>
                            <FitContentTableCell>
                                <Tooltip title={translate("Edit destination")} placement="top">
                                    <IconButton
                                        onClick={() => {
                                            onStreamSelected(restream);
                                            onAction("edit");
                                        }}
                                        variant={"borderless"}
                                        color={"secondary"}
                                    >
                                        <Edit24Icon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title={translate("Delete destination")} placement="top">
                                    <IconButton
                                        onClick={() => {
                                            onStreamSelected(restream);
                                            onAction("delete");
                                        }}
                                        variant={"borderless"}
                                        color={"secondary"}
                                    >
                                        <Remove24Icon />
                                    </IconButton>
                                </Tooltip>
                            </FitContentTableCell>
                        </TableRow>
                    );
                })}
            </TableBody>
        </StyledTable>
    );
};

export default RestreamsTable;
